/**
 * Modal component for managing generated content
 */

import React from 'react'
import { Modal, Button, Icon, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import ClickableTextArea from '../ClickableTextArea'

const GeneratedContentModal = ({
  visible,
  onCancel,
  title,
  content,
  references,
  onContentChange,
  onSave,
  onSummarize,
  onAddContentFromInternet,
  showInternetContentLoading
}) => {
  const { t } = useTranslation()

  return (
    <Modal
      onCancel={onCancel}
      visible={visible}
      centered
      className="ai-course__table-of-content__generated-content-modal modal-content-wrap"
      footer={null}
    >
      <Spin
        tip={t('v5:adding_content_from_internet')}
        spinning={showInternetContentLoading}
      >
        <div className="manage-content">
          <h1>
            <Icon type="setting" /> {t('v3:ai_manage_content')}
          </h1>

          <div className="content-section">
            <div className="content-section__title">
              <h2>{title}</h2>
              <span
                className="add-content-btn"
                onClick={onAddContentFromInternet}
              >
                {t('v3:ai_add_content_from_internet')}
              </span>
            </div>

            <ClickableTextArea
              text={content}
              references={references}
              onChange={onContentChange}
            />
          </div>

          <div className="button-group">
            <Button
              shape="round"
              type="default"
              className="summarize-btn"
              onClick={onSummarize}
              style={{ marginLeft: '10px' }}
            >
              {t('v4:edit_content')}
            </Button>
            <Button
              shape="round"
              type="primary"
              className="save-btn"
              onClick={onSave}
            >
              {t('general:save')}
            </Button>
          </div>
        </div>
      </Spin>
    </Modal>
  )
}

export default GeneratedContentModal
